import axios from "../plugins/axios";

const apiUrl = process.env.REACT_APP_WORKNEST_TOOLS_API_URL;

interface MyVisitsParams {
    page: number;
    rowsPerPage: number;
}

export interface MyVisitsResponse {
    totalCount?: number;
    entries?: unknown[];
    [k: string]: unknown;
}

export interface VisitSummary {
    consultantName: string;
    consultantJobTitle: string;
    consultantNextVisitDate: string;
    consultantNextVisitTime: string;
    consultantTickerTillNextVisit: string;
    daysTillEndOfMonth: number;
    consultantMonthlyPercentage: number;
    consultantMonthlyVisitCount: number;
    consultantMonthlyTarget: number;
    consultantAnnualPercentage: number;
    consultantAnnualVisitCount: number;
    consultantAnnualTarget: number;
    regionalMonthlyPercentage: number;
    regionalAnnualPercentage: number;
}

const fetchMyVisits = async ({ page, rowsPerPage }: MyVisitsParams): Promise<MyVisitsResponse> => {
    try {
        const { data: myVisits } = await axios.get(
            `${apiUrl}/myvisits?page=${page}&rows=${rowsPerPage}`,
        );
        return myVisits;
    } catch (e: any) {
        return Promise.reject(
            e?.data?.message ?? "Could not fetch visits for user.",
        );
    }
};

const fetchVisitSummary = async (): Promise<VisitSummary> => {
    try {
        const response = await axios.get<VisitSummary>(`${apiUrl}/visitsummary`);
        return response.data;
    } catch (e: any) {
        console.error(e);
        return Promise.reject(
            e?.message || "Could not fetch visit automation window.",
        );
    }
};

const timesheetService = {
    fetchMyVisits,
    fetchVisitSummary,
};

export default timesheetService;
